import React, { Fragment, Component } from 'react'
import { Layout, Button, Icon, Row, Col, Collapse} from 'antd';
import {ActivityImproveShadeImage} from '../../../assets/images';
import InfiniteScroll from 'react-infinite-scroller';
const {Content } = Layout;
const { Panel } = Collapse;

class ActivitiesDrawer extends Component {
  constructor(props) {
    super(props);
    this.state = {
    }
  }

  callback(key) {
    console.log(key);
  } 


  render() {
    return (
      <div>
        <h2  style={{marginBottom: 24}} className="activities-pre-header">Recommended Activities</h2>
          <div style={{paddingTop: 70}}>
          </div>

          <div className="activities-infinite-container" >
            <InfiniteScroll
              initialLoad={false}
              pageStart={0}
              useWindow={false}
            >
              <Collapse
                defaultActiveKey={["1"]}
                onChange={this.callback.bind(this)}
                expandIconPosition='right'
              >
                <Panel header="Desktop Yoga" key="1">
                  <div>Yoga taught at the workstations to overcome or prevent work related disorders. They wipe away body pain, fatigue and tension and increase overall muscle strength and flexibility, keeping you fresh and revitalized through the day. The exercises don’t demand much time, and can be done in spurts throughout the day, sparing you from unnecessary discomfort in the long run.</div>
                </Panel>
                <Panel header="Chair Meditation" key="2">
                  <div>Desk exercises for the cubicle-bound, won’t promise Olympic mile times or six-pack abs but improve strength and burn a few extra calories to boot. So whether it’s Powerpoint, Photoshop, or emails on that to-do list, we have a routine for a healthier workday.</div>
                </Panel>
                <Panel header="Mindfulness & Stress reduction" key="3">
                  <div>A powerful complement to yoga, our mindfulness classes use guided centering techniques to create deep mental stillness. Our certified mindfulness instructors help even the busy bees slow down to achieve deep relaxation and tranquility while tapping hidden reserves of creativity, concentration and emotional freedom.</div>
                </Panel>
                <Panel header="Hatha Yoga" key="4">
                  <div>Hatha Yoga uses postures (asanas) and stretches in combination with the breath to develop flexibility and relaxation. It encourages proper alignment of the body and brings balance, strength, and calmness to the practitioner. The session ends with a meditative relaxation exercise and chant</div>
                </Panel>
                <Panel header="Stretch & relax" key="5">
                  <div>The session invloves deliberately flexing or stretching in order to improve the muscle's felt elasticity and achieve comfortable muscle tone. The result is a feeling of increased muscle control, flexibility, and range of motion.</div>
                </Panel>
                <Panel header="Chair Meditation" key="6">
                  <div>Desk exercises for the cubicle-bound, won’t promise Olympic mile times or six-pack abs but improve strength and burn a few extra calories to boot. So whether it’s Powerpoint, Photoshop, or emails on that to-do list, we have a routine for a healthier workday.</div>
                </Panel>
                <Panel header="Laughter Yoga" key="7">
                  <div>Great de-stresser added as the last segment to all the yoga sessions.( Group activity)</div>
                </Panel>
                <Panel header="Ergonomics" key="8">
                  <div>Workshop covering the basics of ergonomics that can help employees in workplace; focused around overcoming effects of sedentary lifestyle</div>
                </Panel>
                <Panel header="Flashmob(Dance Masala Mix)" key="9">
                  <div>A fun filled workout based on popular dance formats and music. First 5 mins of ice-breaking session is followed by employees learning the workout moves with beats, which they perform all together as a MOB in the last 10 mins.</div>
                </Panel>
                <Panel header="Aerobics" key="10">
                  <div>An intense aerobics class that burns 30 - 60 % more calories than traditional aerobics with particular emphasis on hips, thighs, abdominals, and buttocks.</div>
                </Panel>
                <Panel header="Dance Masala Mix" key="11">
                  <div>Cardio workout that follows the re-stimulation principle and promises to burn upto 400 calories in an hour long class with a music mix of hip-hop, Pop, Bhangra, Meringue, Salsa, bollywood, Jazz. </div>
                </Panel>
                <Panel header="Masala Bhangra" key="12">
                  <div>This workout gets heart pumping and targets the full body through the famous moves of shoulder shrugging, toe tapping, and head shaking to the contagious beat of a dhol. </div>
                </Panel>
                <Panel header="Zumba" key="13">
                  <div>Dance-based fitness class that uses a fusion of Latin and International  rhythms with easy-to-follow moves. It includes both cardio and resistance training components designed to tone and sculpt the entire body. </div>
                </Panel>
                <Panel header="Fitness Challenge" key="14">
                  <div>A participative event where certified fitness coaches engage the audience through various fun fitness challenges and reward the winners/ successful completions (battle rope challenge, plank challenge, 60 minute squats and 10 other challenges to choose from).</div>
                </Panel>
                <Panel header="Self-Defense" key="15">
                  <div>A beginner to advance level workshop for employees focusing on developing practically useful skills oriented towards self defense</div>
                </Panel>
                <Panel header="Stress Management" key="16">
                  <div>A spectrum of techniques aimed at controlling a person's levels of stress, especially chronic stress, usually for the purpose of improving everyday functioning.</div>
                </Panel>
                <Panel header="Healthy Salad Making Workshop" key="17">
                  <div>Expert talks about importance of salads and demonstrates art of making healthy salads….up to 2 recipes</div>
                </Panel>
                <Panel header="Smoking Cessation" key="18">
                  <div>A quit smoking information session that helps with taking important steps toward a goal of tobacco-free living. Increase an understanding of the dynamics of tobacco addiction, learn the different methods available to help quit.</div>
                </Panel>
                <Panel header="HIIT" key="19">
                  <div>HIIT, or high-intensity interval training, is a training technique in which there are intense bursts of exercise, followed by short, sometimes active, recovery periods. This type of training gets and keeps your heart rate up and burns more fat in less time.</div>
                </Panel>
              </Collapse>
            </InfiniteScroll>
          </div>
          
          <div className="activities-footer">
            <h5 style={{paddingTop: 25}}>Please reach out to <span className="semibold" style={{color: '#2168f3'}}>{sessionStorage.getItem('hr_contact_email')}</span> to learn more</h5>
          </div>

      </div>
    );
  }
}

export default ActivitiesDrawer;